import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated, getAuthRedirect, setAuthRedirect } from '../reducers/user';

const PrivateRoute = ({ component: Component, path, location, ...rest }: any) => {
  const dispatch = useDispatch();
  const isAuth = useSelector(isAuthenticated);
  const authRedirect = useSelector(getAuthRedirect);

  const render = (props: any) => {
    if (isAuth === true) {
      return <Component {...props} />;
    } else {
      if (authRedirect == null) {
        dispatch(setAuthRedirect(location.pathname));
      }
      return <Redirect to="/login" />;
    }
  };

  return <Route path={path} render={render} {...rest} />;
};

export default PrivateRoute;
